import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Join from './components/Join';
import Footer from './components/Footer';
import Map from './components/Map';
import Experiments from './components/Experiments';

function HomePage() {
  React.useEffect(() => {
    // Handle hash scrolling when component mounts
    const hash = window.location.hash;
    if (hash) {
      // Remove the # and get the section id
      const sectionId = hash.substring(1);
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <Hero />
      <About />
      <Join />
    </>
  );
}

function MapPage() {
  return (
    <Map />
  );
}

function AppContent() {
  const location = useLocation();
  const showFooter = location.pathname !== '/map';

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/experiments" element={<Experiments />} />
      </Routes>
      {showFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
